/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-10T16:12:05-07:00
*/

import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, borders,  } from '../../style';

const style = StyleSheet.create({
  heading: {
    alignItems: 'baseline',
    display: 'flex',
    justifyContent: 'space-between',
    ...spacing.PADDING_V_MD,

    [dimensions.SCREEN_MAX_MD]: {
      ...spacing.MARGIN_BOTTOM_SM,
      ...spacing.PADDING_LEFT_SM,
      ...spacing.PADDING_RIGHT_SM,
    }
  },

  borderBottom: {
    borderBottom: borders.DEFAULT,
    ...spacing.MARGIN_BOTTOM_LG,

  },

  size_SM: {
      ...spacing.PADDING_V_SM,

      [dimensions.SCREEN_MAX_MD]: {
        ...spacing.MARGIN_BOTTOM_SM,
      }
  },

  bleedToEdges: {
    [dimensions.SCREEN_MAX_MD]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  }
})

const Header = (props) => {

  const {
    children,
    bottomRule,
    bleedEdges,
    size,
    ...rest
  } = props

  const bordered = bottomRule === false ? false : true

  return (
    <div className={css(
                      style.heading,
                      size && style[`size_${size}`],
                      bleedEdges && style.bleedToEdges,
                      bordered && style.borderBottom
                    )}>
      {children}
    </div>
  )
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/blocks/Header.jsx